var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$slots.default)?_c('div',[_vm._t("default"),(!_vm.withoutBottomLine)?_c('hr',{staticClass:"my-2"}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }